import React from 'react';
import { SEO } from '../components/SEO';
import { PersonalHero } from '../components/PersonalHero';
import { StatsBar } from '../components/StatsBar';
import { StorySection } from '../components/StorySection';
import { JourneyTimeline } from '../components/JourneyTimeline';
import { UniqueValue } from '../components/UniqueValue';
import { ResultsSection } from '../components/ResultsSection';
import { PhilosophySection } from '../components/PhilosophySection';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <SEO title="Justus Kraft - CRM Experte | Vertriebs-Automatisierung" description="Mit 16 Jahren mein erstes Gewerbe gegründet. Heute, mit 23 Jahren, helfe ich Unternehmen, ihren Vertrieb durch intelligente CRM-Systeme zu verdoppeln. 110+ zufriedene Kunden, DSGVO-konform." keywords="CRM Experte, Vertriebsautomatisierung, CRM Beratung, Justus Kraft, CRM Kraft, B2B Vertrieb, B2C Vertrieb, CRM Systeme, Vertriebsoptimierung" data-id="element-422" data-mp="2rzbdbf9g248v" />
      <main data-id="element-423" data-mp="2antvkzxzuzhp">
        <PersonalHero data-id="element-424" data-mp="2aodb6a069bsk" />
        <StatsBar data-id="element-425" data-mp="2amsgmkduxsup" />
        <StorySection data-id="element-426" data-mp="2eqgm8xixiedb" />
        <JourneyTimeline data-id="element-427" data-mp="2epotrvkmowr9" />
        <UniqueValue data-id="element-428" data-mp="2eox7xcgu2de6" />
        <ResultsSection data-id="element-429" data-mp="2eodn9nzstawg" />
        <PhilosophySection data-id="element-430" data-mp="2jhgmabnchck1" />
        <FinalCTA data-id="element-431" data-mp="2ji850lvuffsw" />
      </main>
    </>;
}